<template>
  <div class="main">
    <header>
      <div class="logout" id="logout" v-show="showLogin" @mouseleave="hideLogin" @mouseenter="showLoginMark">
        <li v-show="!token" style="cursor: pointer" @click="toLoginPage">登录</li>
        <li v-show="token" style="cursor: pointer" @click="logout">登出</li>
      </div>
      <div class="top">
        <div class="login" style="border-radius: 0">
          <img @click="toHomePage" style="border-radius: 0; cursor: pointer;"
               src="../../../static/assets/images/maimai.png" alt="">
        </div>
        <div class="header_content">
          <li><h3>{{title}}</h3></li>
          <br>
        </div>
        <div class="login" @mouseleave="hideLogin" @mouseenter="showLoginMark">
          <img :src="avatarUrl" alt="">
          {{ displayName }}
        </div>
      </div>
    </header>
    <!--<div class="content" v-loading="loading">
      <div class="gray-box">
        <div class="gray-box-left">
          <div class="big-img" v-show="productId == 1">
            <img src="../../../static/image/product/1_index.jpg" style="width: 240px; height: 240px;"/>
          </div>
          <div class="big-img" v-show="productId == 2">
            <img src="../../../static/image/product/2_index.jpg" style="width: 240px; height: 240px;"/>
          </div>
          <div class="big-img" v-show="productId == 3">
            <img src="../../../static/image/product/3_index.jpg" style="width: 240px; height: 240px;"/>
          </div>
          <div class="big-img" v-show="productId == 4">
            <img src="../../../static/image/product/4_index.jpg" style="width: 240px; height: 240px;"/>
          </div>
        </div>

        <div class="gray-box-right">
          <p class="title">{{labelTitle}}</p>
          <br><br>
          <p class="price">指导价：<span>¥{{labelPrice}}</span>
          </p>
          <em @click="executePaymentWap">立即购买</em>
        </div>
      </div>
      <div v-show="productId == 1">
        <div class="brandDiv" style="text-align: center; font-size: 18px">
          <p>相信不少人都喝过茅台酒，但是会品茅台酒的却很少，</p>
          <br>
          <p>特别是现在茅台酒的价格水涨船高，如果大口大口的喝掉的话，还没品出味道就喝完了，这样浪费了一瓶好酒！</p>
          <br>
          <p>所以说学会品鉴茅台酒是非常重要的。茅台老酒鉴定课，此课程让你在这里学到更多，涉及多个范围，使你更专业，让你成为鉴酒大师。</p>
        </div>
        <br>
        <br>
        <div class="brandDiv" style="text-align: center">
          <img src="../../../static/image/product/1_1.png" alt=""/>
        </div>
        <br>
        <br>
        <div class="categoryDiv" style="text-align: center">
          <img src="../../../static/image/product/1_2.png" alt=""/>
        </div>
      </div>

      <div v-show="productId == 2" style="text-align: center">
        <br>
        <br>
        <div class="brandDiv" style="text-align: center">
          <img src="../../../static/image/product/2_1.png" alt=""/>
        </div>
        <br>
        <br>
        <div class="brandDiv" style="text-align: center; font-size: 18px">
          <p>融实用性、知识性与趣味性于一体</p>
          <br>
          <p>酒是人类生活中特有的一种精神文化产品，其所蕴含的精神与文化层面的东西远远超出了其物质属性,所以我们不能把酒与普通的食品及饮料混为一谈。</p>
          <br>
          <p>围绕实践能力的提高来编写教材，内容系统翔实，酒标丰富多样。重点突出了各类酒品的鉴赏要领、服务程序与饮用方法。</p>
          <br>
          <p>推开一扇了解酒品、鉴赏酒品、品味名酒的窗，开启一次次快乐的心灵之旅！</p>
        </div>
        <br><br>
        <div class="categoryDiv" style="text-align: center">
          <img src="../../../static/image/product/2_2.png" alt=""/>
        </div>
      </div>

      <div v-show="productId == 3" style="text-align: center;font-size: 18px">
        <br><br>
        <h3>胶帽</h3>
        <br>
        <p>2009年2月茅台启用新防伪红色胶帽，并将瓶盖上的物流码标改贴在背标。标贴由条形码、数字串、国酒茅台标识三要素组成。</p>
        <div class="brandDiv" style="text-align: center">
          <img src="../../../static/image/product/3_1.png" alt=""/>
        </div>
        <br>
        <br>
        <div class="brandDiv" style="text-align: center; ">
          <h3>物流码变更前后</h3>
          <br>
          <p>胶帽上第一排日期喷码，从2000年开始由6位改为8位，如“991112”改为“20001112”。</p>
          <br>
          <p>第二排生产批次由4位改为6位，如“99-10”改为“2000-10”，字体稍窄，2000年开始喷码的数字“0”内没有斜杆。</p>
          <br>
          <p>第三排生产序号由顶格改为空一格。2017年后，在5位序号前增加一组英文字母，如'AA01564'。如果2018年的酒，第三行喷码前没有英文字母，或者2017年以前的酒，第三行喷码前有英文字母，那就是假酒了。</p>
          <br>
          <h3>正标</h3>
          <br>
          <p>茅台酒正标的变化主要从2001年开始的。</p>
          <br>
          <p>2001年6月13日，“飞天牌”茅台酒上启用不干胶商标，“五星牌”贵州茅台酒从8月9日开始使用。</p>
          <br>
          <p>2001年8月27日，茅台集团正式上市，此后，茅台酒瓶上的厂名落款从“中国贵州茅台酒厂出品”改为“贵州茅台酒股份有限公司出品”的字样。</p>
          <br>
        </div>
        <div class="categoryDiv" style="text-align: center">
          <img src="../../../static/image/product/3_2.png" alt=""/>
        </div>
      </div>


      <div v-show="productId == 4" style="text-align: center;font-size: 18px;">
        <br><br>
        <div class="categoryDiv" style="text-align: center">
          <img src="../../../static/image/product/4_1.png" alt=""/>
        </div>
        <br> <br>
        <div class="brandDiv" style="text-align: left; font-size: 18px">
          <p style="text-align: center"> 近些年，洋酒已经被大众所熟知并真真切切地进入了我们的生活。</p>
          <p style="text-align: center">无论是闲暇时的聚会共饮还是无聊时的自斟自酌，或是单纯感受不同酒类的不同风味，都是一件乐事。</p>
          <br>
          <br>
          <h3 style="text-align: center;">鉴别真假威士忌的主要方法</h3>
          <br>
          <p><b>1、看色泽</b>:</p>
          <br>
          <p>
            拿酒杯时应该拿住杯子的下方杯脚，而不能托着杯壁。因为手指的温度会让杯中的酒发生微妙的变化。
          </p>
          <br>
          <br>
          <p><b>2、看挂杯</b>: </p>
          <br>
          <p>首先把这酒杯慢慢地倾斜过来。请注意一定要很轻柔很小心，然后再恢复原状。你会发现酒从杯壁流回去的时候，留下了一道道酒痕，这就是酒的挂杯。</p>
          <br>
          <br>
          <p><b>3、闻香味</b>: </p>
          <br>
          <p>如“格兰菲迪”威士忌是一种单一麦芽株酒，可以在酒里加适量的水，所谓适量就是加入杯子里酒的大约1/3的水。因为水可以把香味带出来。</p>
          <br>
          <br>
          <p><b>4、品</b>: </p>
          <br>
          <p>在酒杯中注入半杯威士忌，倾斜酒杯缓缓旋转酒杯，酒质醇厚者流动较慢，在杯壁停留时间较长，将酒杯内的酒液倒出，静置１小时，酒香仍可闻到。</p>
          <br>
          <br>
          <br>
        </div>
      </div>
    </div>-->
    <span style="margin-top:5%; margin-left: 45%;text-align: center;color: #6e6e6e;">作者: {{newData.author}}</span>
    <div v-html="htmlCode" style="margin-top:5%; margin-left: 25%;margin-right: 100px; width: 50%; text-align: center"></div>
    <br>
    <br>

    <div class="content" style="text-align: center">
      <h3>相关商品</h3>
      <ul style="text-align: center">
        <li style="cursor: pointer" class="shadow" v-for="(item, index) in keywordProducts"
            @click="toProductDetailsPage(item.id)" :key="index">
          <div class="img">
            <img :src="item.masterImageUrl"/>
          </div>
          <div class="main_content">
            <span class="title" style="font-size: 16px;"><b>{{ item.name }}</b></span>
            <div style="text-align: center;font-weight: bolder" v-if="item.lowestAskPrice != null"><span >￥{{item.lowestAskPrice}}</span></div>
            <div style="text-align: center" v-if="item.lowestAskPrice == null"><span >暂无出售</span></div>

            <!--            <span class="subtitle"></span>-->
          </div>
        </li>
      </ul>
    </div>

    <!--<div style="margin-left: 20px;">
      <el-row>
      <el-col :span="4" v-for="(o, index) in keywordProducts" :key="o">
        <el-card>
          <img :src="o.masterImageUrl" style="width: 100%;height: 100%;">
          <div style="padding: 14px;">
            <span>{{o.name.length >20 ? o.name.substr(0,20)+'...' : o.name}}</span>
            <div class="bottom clearfix">
              <el-button type="text" class="button">查看详情</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    </div>-->
    <br>
    <br>
    <br>
    <br>
    <br>

    <Footer style="position: fixed; bottom: 0;"></Footer>
  </div>
</template>

<script>
import qs from 'qs';
import Footer from '../../components/common/footer';
export default {
  name: "productDetailsPage",
  props: ['productId'],
  components: {
    Footer
  },
  data() {
    return {
      keywordProducts:[],
      title:'',
      newData:'',
      htmlCode: '',
      html: 'https://www.maltmalt.com/src/files/a/1576135037028/88D5CD32403A4DFEA5BCDFCE78B70DCB.html',
      loading: false,
      showLogin: false,
      token: localStorage.getItem('token'),
      currentIndex: 0,
      isMark: false,
      showHeader: false,
      labelTitle: "",
      labelPrice: "",
      detailObject: {},
      productInfo: {},
      attributes: [],
      productImages: [],
      bigProductImage: "",
      productBrandImageUrl: "",
      productBrandDescription: "",
      description: "",
      productBrandAdditionalUrl: "",
      platformServiceImageUrl: "",
      productCategoryImageUrl: "",
      productCategoryDescription: "",
      orderPreview: {},
      fees: [],
      expectPrice: "",
      price: "",
      userAddress: {},
      showCode: false,
      avatarUrl: "",
      displayName: localStorage.getItem('name'),
      image: ""
    }
  },

  created() {
    this.getData()
  },
  mounted() {
    let logout = document.getElementById('logout');
    logout.style.right = (document.body.clientWidth - 1220) / 2 + 'px';
    this.avatarUrl = localStorage.getItem('avatarUrl') || require('../../../static/image/header.jpg');
  },
  methods: {
    toProductDetailsPage(productId) {
      this.$router.push({
        path: "/productDetails/" + productId
      })
    },
    toProductPage() {
      this.$router.push({
        path: "/server"
      })
    },
    toLoginPage() {
      this.$router.push({
        name: "loginPage"
      })
    },

    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('name');
      localStorage.removeItem('avatarUrl');
      this.$router.push({
        name: "productPage"
      })
    },

    showLoginMark() {
      this.showLogin = true;
    },

    hideLogin() {
      this.showLogin = false;
    },

    toPay() {
      this.executePaymentWap();
    },

    toHomePage() {
      this.$router.push({
        path: "/"
      })
    },

    executePaymentWap() {
      if (this.token) {
        this.loading = true;
        this.$store.dispatch('payServerProductOrder', 1).then((res) => {
          if (res.data.code == 200) {
            const div = document.createElement('div');
            div.innerHTML = res.data.data;
            document.body.appendChild(div);
            document.forms[0].submit();
            this.loading = false;
          } else {
            Toast({
              message: res.data.message,
              position: 'bottom',
              duration: 2000
            })
          }
        }).catch((error) => {
          let obj = {
            message: error.message,
            pageName: this.$route.name
          };
          lazyload.addException(obj);
        })
      } else {
        this.$router.push({'path': '/login'})
      }
    },


    tobuy: function () {
      if (this.token) {
        this.getBuyerOrderPreview();
      } else {
        this.$router.push({'path': '/login'})
      }
    },

    hideMark() {
      this.isMark = false;
      document.documentElement.style.overflowY = 'auto';
    },

    /*getBuyerOrderPreview() {
      let obj = {
        id: this.productId
      };
      this.$store.dispatch('payProductOrder', obj).then((res) => {
        this.isMark = true;
        if (res.data.code == 200) {
          this.orderPreview = res.data.data;
          if (this.orderPreview.userAddress == null || this.orderPreview.userAddress == undefined) {
            this.showCode = true;
          } else {
            this.showCode = false;
            document.documentElement.style.overflowY = 'hidden';
            this.fees = this.orderPreview.fees;
            this.price = this.orderPreview.product.lowestAskPrice;
            this.userAddress = this.orderPreview.userAddress;
            let fee = 0;
            this.fees.forEach((item) => {
              if (item.feeTypeId == 2) {
                fee += Number(this.biddingPrice * parseInt(item.value) / 100);
              } else {
                fee += Number(item.value);
              }
            });
            this.expectPrice = Number(this.price) + Number(fee);
          }
        }
      })
    }*/
    changImage(imageUrl, index) {
      this.bigProductImage = "";
      this.bigProductImage = imageUrl;
      this.currentIndex = index;
    }
    ,
    getData() {
      /*if (this.productId == 1) {
        this.labelPrice = 9.9;
        this.labelTitle = "鉴酒视频课";
      } else if (this.productId == 2) {
        this.labelPrice = 15;
        this.labelTitle = "鉴酒服务";
      } else if (this.productId == 3) {
        this.labelPrice = 4.9;
        this.labelTitle = "茅台鉴别指南";
      } else if (this.productId == 4) {
        this.labelPrice = 4.9;
        this.labelTitle = "威士忌鉴别指南";

      }*/
      this.$store.dispatch('findNewsDetails', this.productId).then((res) => {
        if (res.data.code == 200) {
          this.htmlCode = res.data.data.content;
          this.title = res.data.data.title;
          this.newData = res.data.data;
          if(res.data.data.keyword !='' || res.data.data.keyword !=null){
            this.$store.dispatch('searchByMultipleKeywords', res.data.data.keyword).then((res) => {
              if (res.data.code == 200) {
                this.keywordProducts = res.data.data;
              }
            })
          }
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.active {
  border: 2px solid #fa7a7a;
}

.activeNo {
  border: 1px solid #f2f2f2;
}

/deep/ .el-table {
  thead {
    .cell {
      text-align: left; // table 表头 左对齐
    }
  }

  .delete-row {
    color: #d8d8d8;
  }

  .el-table__expand-icon { //修改 el-tabel 折叠按钮的位置
    float: right;
  }

  // 去掉table的border start----------------------------
  border: 0;

  th,
  tr,
  td {
    border: 0;
    background-color: #fff;
  }

  &::before {
    height: 0px;
  }

  &::after {
    width: 0;
  }

  .el-table__fixed:before {
    height: 0;
  }

  // 去掉table的border end----------------------------
}

.main {
  width: 100%;

  header {
    width: 100%;
    background: #fff;
    height: 100px;
    position: relative;

    .logout {
      width: 100px;
      height: 50px;
      position: absolute;
      top: 70px;
      border: 1px solid #f2f2f2;
      border-radius: 6px;
      background: #fff;

      li {
        text-align: center;
        line-height: 50px;
      }
    }

    .top {
      height: 100px;
      width: 1220px;
      margin: 0 auto;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .login {
        width: auto;
        height: 50px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;

        img {
          display: block;
          width: 50px;
          height: auto;
          border-radius: 50%;
          margin-right: 10px;
        }
      }

      .search {
        width: 700px;
        height: 50px;
        background: #fff;

        input {
          width: 600px;
          outline: none;
          border: none;
          height: 48px;
          font-size: 18px;
        }

        label {
          width: 50px;
          height: 50px;
          display: block;

          img {
            display: block;
            width: 30px;
            height: auto;
            margin: 10px 10px;
          }
        }
      }

      .allCategory {
        margin-top: 20px;
        float: right;
        margin-right: 560px;
      }
    }
  }

  .mark {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;

    .mark-code {
      width: 500px;
      background: #fff;
      min-height: 450px;
      padding-top: 20px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 18px;

      img {
        display: block;
        width: 200px;
        height: auto;
        margin-top: 20px;
      }
    }

    .mark-content {
      width: 500px;
      background: #fff;
      min-height: 200px;
      border-radius: 6px;
      padding-top: 30px;
      padding-bottom: 40px;

      .address {
        width: 70%;
        margin: 0 auto;
        font-size: 18px;
        border-top: 5px solid #f2f2f2;
        padding-top: 20px;

        .address_user {
          display: flex;
          justify-content: space-between;
        }
      }

      .p1, .p2 {
        width: 70%;
        font-size: 18px;
        margin-left: 15%;
        display: flex;
        padding: 10px 0;

        span {
          display: block;
        }

        .span1 {
          width: 30%;

        }

        .span2 {
          width: 70%;
          text-align: right;
        }
      }

      .p2 {
        color: #ccc;
      }

      .p3 {
        width: 70%;
        font-size: 18px;
        margin-left: 15%;
        display: flex;
        padding: 30px 0 20px;
        border-top: 1px solid #f2f2f2;
        margin-top: 20px;

        .span1 {
          width: 30%;
        }

        .span2 {
          width: 70%;
          text-align: right;
          font-weight: 500;
          font-size: 26px;
        }
      }

      .button {
        width: 70%;
        margin-left: 15%;
        height: 50px;
        text-align: center;
        line-height: 50px;
        background: #fa7a7a;
        color: #fff;
        margin-top: 50px;
        font-size: 18px;
        cursor: pointer;
      }
    }
  }

  .content {
    margin: 0 auto;

    ul {
      display: flex;
      flex-wrap: wrap;

      li {
        width: 25%;
        padding-bottom: 15px;

        .img {
          width: 100%;
          height: 300px;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            height: 80%;
            width: auto;
            display: block;
          }
        }

        .main_content {
          width: 90%;
          margin-left: 5%;
          margin-top: 5%;

          .title {
            font-weight: 500;
            overflow: hidden;
            height: 80px;
            display: flex;
            align-items: center;
            vertical-align: middle;
            text-align: center;
          }

          .subtitle {
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            display: -webkit-box;
            overflow: hidden;
            -webkit-box-orient: vertical;
            text-align: center;
            color: #626262;
            //padding-bottom: 10px;
            margin-top: 10px;
            height: 40px;

          }

          .liBottom {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-around;
            flex-direction: row;
            width: 94%;
            margin-left: 3%;
            margin-top: 20px;

            i {
              display: block;
              font-style: normal;
              width: 50%;
              font-size: 20px;
              text-align: center;
            }

            em {
              display: block;
              font-style: normal;
              width: 50%;
              text-align: center;
              color: #ccc;
              font-size: 14px;
            }
          }
        }
      }
    }
  }

  .header_content {
    height: 100px;
    float: right;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    li {
      padding: 0 40px;
      font-size: 18px;
      color: #555;
      cursor: pointer;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/product/serverProductDetailsPage.vue